var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 59,
    viewBox: "0 0 183 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3837_15649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.6432 18.7858C94.5388 26.9719 101.98 31.5398 107.585 34.2559C113.343 37.0424 115.278 38.8295 115.255 41.3217C115.212 45.1354 110.661 46.8187 106.403 46.8841C98.9737 46.9985 94.6539 44.8894 91.2198 43.2943L88.5434 55.7476C91.989 57.3263 98.3689 58.7033 104.985 58.7637C120.515 58.7637 130.675 51.1406 130.73 39.3214C130.791 24.3212 109.865 23.4909 110.008 16.7862C110.057 14.7532 112.008 12.5837 116.283 12.0321C118.399 11.7535 124.24 11.5402 130.862 14.5727L133.461 2.52388C129.9 1.23441 125.323 -0.000328064 119.624 -0.000328064C105.007 -0.000328064 94.7261 7.72654 94.6432 18.7858ZM158.437 1.0375C155.601 1.0375 153.211 2.68239 152.144 5.2066L129.961 57.8787H145.479L148.567 49.3919H167.531L169.322 57.8787H183L171.064 1.0375H158.437ZM160.608 16.3924L165.086 37.7369H152.821L160.608 16.3924ZM75.8278 1.03821L63.5954 57.878H78.3833L90.61 1.03679H75.8278M53.9514 1.03679L38.5594 39.7259L32.3331 6.83017C31.6025 3.15795 28.7174 1.0375 25.5135 1.0375H0.352418L0 2.68808C5.16546 3.80268 11.0343 5.60041 14.59 7.52395C16.7659 8.69897 17.3864 9.72614 18.1013 12.5183L29.8941 57.8787H45.5213L69.4799 1.0375L53.9514 1.03679Z",
    fill: "url(#paint0_linear_3837_15649)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3837_15649",
    x1: 8413.24,
    y1: 176.644,
    x2: 8582.39,
    y2: -5858.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3837_15649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 59,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosVisa);
export default __webpack_public_path__ + "static/media/logos_visa.1e94f72276ce35542052e721246d24c2.svg";
export { ForwardRef as ReactComponent };